import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { DOCGEN_TRADE_CONFIRMATION_TASK_BASE_PATH } from '../../../../../../../../../../features/generate/trade-confirmation/task/docgen-trade-confirm-task-routing';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task',
)({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'trade-confirmation-task-list',
        label: 'Trade Confirmations',
        to: DOCGEN_TRADE_CONFIRMATION_TASK_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
